import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { accountsContainer } from 'src/models'
import { MdCloudDownload as DownloadIcon } from 'react-icons/md'
import { Row, Col, Nav } from 'react-bootstrap'
import { application } from 'src/utils'
import { i18nTranslate } from 'src/utils'
import { AccordionBlock, toastState } from 'src/views/components'
import { getSortedAttributes } from 'src/deps'
import './styles.scss'

@observer
class ContractsListCard extends React.Component {
  @observable activeContractList = []
  constructor(props) {
    super(props)
  }
  formatDate = date => {
    let d = new Date(date)
    let month = '' + (d.getUTCMonth() + 1)
    let day = '' + d.getUTCDate()
    let year = d.getUTCFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day
    return [month, day, year].join('/')
  }

  renderContract() {
    const {
      name,
      id,
      createdBy = i18nTranslate('contracts.admin', 'Admin'),
      startTime,
      endTime,
      creditLimit,
      paymentTermName,
      paymentMethod,
      status,
    } = this.props?.contract || {}

    const classNames = application.isMobile
      ? 'align-items-start'
      : 'align-items-end'
    const statusStyle =
      status && status.toLowerCase() === 'active'
        ? 'text-success'
        : 'text-danger'
    const credit = creditLimit
      ? /[$]/g.exec(creditLimit)
        ? creditLimit
        : '$' + creditLimit
      : creditLimit === 0
      ? '$' + creditLimit
      : ''

    const splitPaymentMethod = paymentMethod.split(',')
    const paymentMethodPO = splitPaymentMethod.find(
      payment => payment.toLowerCase() === 'po'
    )

    const startDate = this.formatDate(startTime)
    const endDate = this.formatDate(endTime)
    return (
      <Row noGutters className="bg-white" data-testid="qa-contract-container">
        <Col className="d-flex flex-column">
          <Row noGutters className="contract-title-wrapper align-items-end">
            <Col lg={6} md={6}>
              <h5 className="mb-0">{name}</h5>
            </Col>
            <Col
              className={`d-flex justify-content-end ${classNames} pr-4`}
              lg={6}
              md={6}>
              <div className={`mr-4 text-capitalize ${statusStyle}`}>
                {status}
              </div>
              <Nav.Link
                target="_blank"
                rel="noopener noreferrer"
                className="p-0 text-dark"
                href="https://d3k47hcltskkzh.cloudfront.net/23/studio/assets/v1561010582344_177955681/contract.zip">
                <DownloadIcon className="download-icon" />
              </Nav.Link>
            </Col>
          </Row>
          <Row noGutters className="text-capitalize">
            <Col lg={5}>
              <div className="mb-1" data-testid="qa-contractaccordian-id">
                <span className="contract-colon-align-left">
                  {i18nTranslate('contract.id', 'ID')}
                </span>
                : {id}
              </div>
              <div
                className="mb-1"
                data-testid="qa-contractaccordian-createdby">
                <span className="contract-colon-align-left">
                  {i18nTranslate('contract.createdBy', 'Created By')}
                </span>
                : {createdBy}
              </div>
              <div className="mb-1" data-testid="qa-contractaccordian-start">
                <span className="contract-colon-align-left">
                  {i18nTranslate('contract.start', 'Start')}
                </span>
                : {startDate}
              </div>
              <div className="mb-1" data-testid="qa-contractaccordian-end">
                <span className="contract-colon-align-left">
                  {i18nTranslate('contract.end', 'End')}
                </span>
                : {endDate}
              </div>
            </Col>
            <Col lg={6}>
              <div
                className="mb-1"
                data-testid="qa-contractaccordian-payment-method">
                <span className="contract-colon-align">
                  {i18nTranslate('contract.paymentMethod', 'Payment Method')}
                </span>
                : {paymentMethod}
              </div>
              {creditLimit !== 0 &&
                paymentMethodPO &&
                paymentMethodPO.toLowerCase() === 'po' && (
                  <div
                    className="mb-1"
                    data-testid="qa-contractaccordian-credit-limit">
                    <span className="contract-colon-align">
                      {i18nTranslate('contract.creditLimit', 'Credit Limit')}
                    </span>
                    : {credit}
                  </div>
                )}
              {paymentTermName &&
                paymentMethodPO &&
                paymentMethodPO.toLowerCase() === 'po' && (
                  <div
                    className="mb-1"
                    data-testid="qa-contractaccordian-payment-term">
                    <span className="contract-colon-align">
                      {i18nTranslate('contract.paymentTerm', 'Payment Term')}
                    </span>
                    : {paymentTermName}
                  </div>
                )}
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  renderContractColumns = () => {
    const contractList = []
    const propertiesValue =
      accountsContainer?.contractIdResponse?.properties || []

    const setCurrentData = defaultValue => {
      let date = new Date(defaultValue)
      let month = '' + (date.getMonth() + 1)
      let day = '' + date.getDate()
      let year = date.getFullYear()

      if (month.length < 2) {
        month = '0' + month
      }
      if (day.length < 2) {
        day = '0' + day
      }

      return `${month}/${day}/${year}`
    }
    propertiesValue &&
      propertiesValue.map(data => {
        const { required = false, name } =
          this.isOptionalAttribute(data.attributeId) || {}
        if (required === true) {
          const attributesValue =
            accountsContainer?.accountAttributesWithoutSize?.attributes || []
          const propertyAttribute = attributesValue.find(
            attribute => attribute.identifier === data.attributeId
          )
          contractList.push({
            label: name,
            value:
              propertyAttribute.fieldtype.toLowerCase() === 'date'
                ? setCurrentData(data.value)
                : data.value,
            attributeId: data.attributeId,
            sequence: propertyAttribute.sequence,
          })
        }
      })

    const isSequenceAvailable = sortableAttributes =>
      sortableAttributes.filter(attribute => attribute.sequence).length > 0

    let activeProperties = [...contractList]

    activeProperties = isSequenceAvailable(activeProperties)
      ? getSortedAttributes(activeProperties)
      : activeProperties

    this.activeContractList = activeProperties
  }
  isOptionalAttribute = attributeid => {
    const attributesValue =
      accountsContainer?.accountAttributesWithoutSize?.attributes || []
    const attributes = attributesValue.find(
      list =>
        list.identifier === attributeid &&
        list.required === true &&
        list.status.toLowerCase() === 'active'
    )
    return attributes === undefined ? false : attributes
  }
  renderContractList = props => {
    const { list, customClassName, isEven } = props
    const { label, value } = list || {}
    const columnName = isEven ? 5 : 6
    return (
      <Col lg={columnName}>
        <div className="mb-1" data-testid="qa-contract-properties">
          <span
            className={`${customClassName}`}
            data-testid={`qa-attribute-name-${label}`}>
            {label}
          </span>
          : <span data-testid={`qa-attribute-value-${value}`}>{value}</span>
        </div>
      </Col>
    )
  }

  renderContractsAttributes = () => {
    return (
      <React.Fragment>
        {this.activeContractList.length > 0 && (
          <Row
            noGutters
            className="bg-white"
            data-testid="qa-contract-attributes">
            <Col className="d-flex flex-column">
              <Row noGutters className="contract-title-wrapper align-items-end">
                <Col lg={6} md={6}>
                  <h5 className="mb-0" data-testid="qa-attribute-title">
                    {i18nTranslate('contract.attributeTitle', 'Attributes')}
                  </h5>
                </Col>
              </Row>
              <Row noGutters className="attribute-list-wrapper">
                {this.activeContractList.length > 0 &&
                  this.activeContractList.map((list, index) =>
                    this.renderContractList({
                      list,
                      isEven: index % 2 === 0,
                      customClassName:
                        'contract-colon-align-left text-capitalize',
                    })
                  )}
              </Row>
            </Col>
          </Row>
        )}
      </React.Fragment>
    )
  }
  handleVisibility = async (props, id) => {
    let params = props
    await accountsContainer.getContractById(id)
    this.renderContractColumns()
    if (this.activeContractList.length === 0) {
      params.isOpen = false
      toastState.setToastMessage(
        i18nTranslate(
          'contract.attributeNotFoundMsg',
          'No properties available for the contract'
        ),
        false
      )
    }
    this.props.handleVisibility(params, id)
  }
  render() {
    const { index, key, isActive, contract } = this.props

    return (
      <div
        className="my-2 contract-table bg-white"
        data-testid="qa-contract-accordian">
        <AccordionBlock
          title={this.renderContract()}
          key={key}
          className="accordion-block-contract"
          index={index}
          isActive={isActive}
          onClick={params => {
            this.handleVisibility(params, contract.id, isActive)
          }}>
          {this.renderContractsAttributes()}
        </AccordionBlock>
      </div>
    )
  }
}

export { ContractsListCard }
